module.exports = __webpack_public_path__ + "static/media/pool-live-icon.8a65c3b8.png";